<template>
  <div>
    <vue-element-loading :active="appLoading" :is-full-screen="true" />
     <v-snackbar v-model="showsnackbar" color="red" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout justify-center wrap>
      <v-flex xs12>
        <v-card class="mb-1">
          <v-card-title
            >Purchase List
            <v-spacer></v-spacer>
            <v-flex xs12 sm6 md2 pt-2 align-self-start>
              <v-select
                v-model="status"
                :items="statusList"
                item-text="text"
                item-value="value"
                label="Delivery Status"
                size
                dense
                outlined
              >
              </v-select>
            </v-flex>
          </v-card-title>
        </v-card>
        <v-layout wrap justify-start v-if="products.length > 0">
          <v-flex xs12 px-2 py-2 v-for="(item, i) in products" :key="i">
            <v-card
              flat
              rounded="xl"
              color="white"
              outlined
              :to="'/Purchase/' + item.order_id"
            >
              <v-layout px-sm-4 pb-1 wrap justify-center>
                <v-flex xs12>
                  <v-layout wrap justify-center>
                    <v-flex xs3 lg3 xl3 pa-2>
                      <v-img
                        :src="baseURL + '/file/get/' + item.productId.photos[0]"
                        height="100px"
                        contain
                      >
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height ma-0"
                            align="center"
                            justify="center"
                          >
                            <v-progress-circular
                              indeterminate
                              color="#FF4343"
                            ></v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-flex>
                    <v-flex xs5 lg5 xl5 style="line-height: 20px">
                      <v-layout wrap justify-center>
                        <v-flex xs12 text-left pt-2>
                          <span style="font-size: 16px; color: #808080">
                            <b> {{ item.orderID }} </b>
                          </span>
                        </v-flex>
                        <v-flex xs12 text-left pt-2>
                          <router-link
                            style="text-decoration: none"
                            :to="'/productDetails/' + item.productId._id"
                          >
                            <span style="font-size: 16px; color: #808080">
                              {{ item.name.slice(0, 25) }}
                              <span v-if="item.name.length > 25"> ... </span>
                            </span>
                          </router-link>
                        </v-flex>
                        <v-flex xs4 text-left>
                          <span style="font-size: 14px; color: #000000">
                            Price: ₹{{ item.price }}
                          </span>
                        </v-flex>
                        <v-flex xs8 text-center>
                          <span style="font-size: 14px; color: #fa0000">
                            Discount: {{ item.discount }}%
                          </span>
                        </v-flex>
                        <v-flex xs12 text-left>
                          <span style="font-size: 14px; color: #000000">
                            Offer Price: ₹{{ item.offerPrice }}
                          </span>
                        </v-flex>
                        <v-flex xs12 text-left>
                          <span style="font-size: 14px; color: #000000">
                            Delivery Status: {{ item.productOrderStatus }}
                          </span>
                        </v-flex>
                        <v-flex xs12 text-left>
                          <router-link
                            style="text-decoration: none"
                            :to="'/Seller/' + item.sellerId.uid"
                          >
                            <span style="font-size: 16px; color: #808080">
                              {{ item.shopName.slice(0, 25) }}
                              <span v-if="item.shopName.length > 25">
                                ...
                              </span>
                            </span>
                          </router-link>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <v-flex xs4>
                      <v-layout wrap justify-center>
                        <v-flex xs12>
                          <span style="font-size: 16px; color: #808080">
                            <b>Customer Details </b>
                          </span>
                        </v-flex>
                        <v-flex xs12 v-if="item.uid">
                          <span
                            >{{ item.uid.customerid.firstName }}
                            {{ item.uid.customerid.lastName }}</span
                          >
                        </v-flex>
                        <v-flex xs12 v-if="item.uid">
                          <span>{{ item.uid.customerid.email }}</span>
                        </v-flex>
                        <v-flex xs12 v-if="item.uid">
                          <span>{{ item.uid.phone }}</span>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>
        <v-layout wrap v-else justify-center pt-10>
          <v-flex md4>
            <h1>Oops!! No Orders found</h1>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <div class="text-center pb-5" v-if="pages > 1">
      <v-pagination
        :length="pages"
        :total-visible="7"
        v-model="currentPage"
        color="red"
      ></v-pagination>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      valid: true,
      page: 1,
      currentPage: 1,
      pages: 0,
      limit: 12,
      showsnackbar: false,
      msg: null,
      ServerError: false,
      validateInput: null,
      timeout: 5000,
      appLoading: false,
      coverphoto: null,
      profilepic: null,
      documents: null,
      products: [],
      statusList: [
        { value: "", text: "All" },
        { value: "ordered", text: "Ordered" },
        { value: "packed", text: "Packed" },
        { value: "shipped", text: "Shipped" },
        { value: "outfordelivery", text: "Out for Delivery" },
        { value: "delivered", text: "Delivered" },
        { value: "cancelled", text: "Cancelled" },
        { value: "Return", text: "Return" },
      ],
      status: "",
    };
  },

  beforeMount() {
    this.getPurchases();
  },
  watch: {
    currentPage() {
      this.getPurchases();
    },
    status: function () {
      this.getPurchases();
    },
  },
  methods: {
    getPurchases() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/admin/orders/products/all/list",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          limit: this.limit,
          page: this.currentPage,
          productOrderStatus: this.status,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.products = response.data.data;
            this.pages = Math.ceil(response.data.totalLength / this.limit);
          }
        })
        .catch((err) => {
         this.appLoading = false;
          this.msg = err.response.data.msg;
          this.msg = "Server Unreachable";
          this.showsnackbar = true;
        });
    },
    formatDate(oldDate) {
      if (oldDate) {
        var newdateFormat = oldDate.split("T");
        var splitDate = newdateFormat[0].split("-");
        if (splitDate.count == 0) {
          return null;
        }

        var year = splitDate[0];
        var month = splitDate[1];
        var day = splitDate[2];

        return day + "/" + month + "/" + year;
      }
    },
  },
};
</script>
